export default "__VITE_ASSET__C_UHm2oP__"